import {Shape} from './Shape.js';
import { fabricArrow } from './fabricArrow.js';
import { ShapeAction } from './ShapeFactory.js';
import { fabric } from 'fabric';
var defaultProps = {
    strokeWidth: 2,
    fill: 'red',
    stroke: 'red',
    class: 'line',
    originX: 'left',
    originY: 'top',
    selectable: true,
    hasBorders: true,
    hasControls: true,
    evented: true
};
class Arrow extends Shape {
    constructor(props) {
        super(props);
        this.newProps = null;
        this.arrow = null;
    }
    draw(props) {
        this.newProps = {
            ...defaultProps,
            ...props
        };
        //working while snapsot
        if (props.action !== ShapeAction.START) {
            let canvasObject = props;
            let arrowObject = new fabricArrow(null, canvasObject);
            delete arrowObject.__corner;
            delete arrowObject._cacheCanvas;
            delete arrowObject._cacheContext;
            delete arrowObject._cacheProperties;
            super.draw(arrowObject);
            this.drawingCanvas.removeEvents();
            return;
        }
        const events = {
            onCanvasMouseDown: this.onMouseDown.bind(this),
            onCanvasMouseUp: this.onMouseUp.bind(this)
        };

        this.drawingCanvas.registerEvents(events);
    }

    onMouseDown(points) {
        this.arrow = new fabricArrow(points, this.newProps);
        console.log('MOUSE DOWN', this.arrow, this.arrow.toObject());
        this.arrow.uuid = this.newProps.uuid;
        this.arrow.uuid_parent = this.newProps.uuid_parent;
        this.drawingCanvas.addAsActiveShape(this.arrow);
        this.drawingCanvas.renderAll();
    }

    onMouseUp() {
        this.drawingCanvas.removeEvents();
        this.newProps.action = ShapeAction.ADD;
        this.arrow.action = ShapeAction.ADD;
        // const { x1, x2, y1, y2 } = this.arrow;
        // const positions = { x1, x2, y1, y2 };
        super.toFebricObject(this.arrow);
        if (this.onDrawCompleted) {
            this.onDrawCompleted({
                ...this.newProps,
                ...this.arrow.toObject(),
                // ... positions
            });
        }
    }
}

export { Arrow };
